import React, { useState } from "react";
import { appStorage } from "../../firebase/config";
import { motion } from "framer-motion";
//add import for storage

const ProfileUpload = (props) => {
  const [imageAsFile, setImageAsFile] = useState("");
  const [progress, setProgress] = useState(0);
  console.log(imageAsFile);
  const handleImageAsFile = (e) => {
    const image = e.target.files[0];
    setImageAsFile(image);
  };

  const handleFireBaseUpload = (e) => {
    e.preventDefault();
    if (imageAsFile === "") {
      console.error(`not an image, the image file is a ${typeof imageAsFile}`);
    }
    const uploadTask = appStorage
      .ref(`/images/${imageAsFile.name}`)
      .put(imageAsFile);
    uploadTask.on(
      "state_changed",
      (snap) => {
        let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;

        setProgress(percentage);
      },
      (err) => {
        //catches the errors
        console.log(err);
      },
      () => {
        // gets the functions from storage refences the image storage in firebase by the children
        // gets the download url then sets the image from firebase as the value for the imgUrl key:
        appStorage
          .ref("images")
          .child(imageAsFile.name)
          .getDownloadURL()
          .then((fireBaseUrl) => {
            props.setInfo({
              ...props.info,
              photoURL: fireBaseUrl,
              filepath: `/images/${imageAsFile.name}`,
            });
            setImageAsFile("");
          });
      }
    );
  };
  return (
    <div>
      <form>
        <form onSubmit={handleFireBaseUpload}>
          <label className="btn btn-dark simplefont size11">
        <i className='fa fa-upload'></i> Choose Image{" "}
          <input
            type='file'
            className='custom-file-control '
            hidden
            onChange={handleImageAsFile}
          />
          </label>
          <motion.div
            className='progress-bar'
            style={{
              height: "5px",
              background: "#efb6b2",
              marginTop: "20px",
            }}
            initial={{ width: 0 }}
            animate={{ width: progress + "%" }}
          ></motion.div>
          <button className='btn btn-outline-dark slantfont'>Upload</button>
        </form>
      </form>
    </div>
  );
};

export default ProfileUpload;
